import {i18n} from "@/plugins/i18n";

export const bankTransferTransactionServiceType = {
    PANEL: 1,
    WEBSERVICE: 2,
    GENERAL_PANEL: 3,
    SYSTEM: 4,
    REJECTION: 5
};

export const bankTransferTransactionServiceTypeStr = {
    PANEL: i18n.t('open_banking.service_types.panel'),
    WEBSERVICE: i18n.t('open_banking.service_types.webservice'),
    GENERAL_PANEL: i18n.t('open_banking.service_types.general_panel'),
    SYSTEM: i18n.t('open_banking.service_types.system'),
    REJECTION: i18n.t('open_banking.service_types.rejection'),

    get(status) {
        let status_str = null;

        Object.keys(bankTransferTransactionServiceType).forEach(item => {
            if (bankTransferTransactionServiceType[item] === status) {
                status_str = bankTransferTransactionServiceTypeStr[item];
            }
        });

        return status_str;
    }
}